import React, {forwardRef} from 'react';
import PropTypes from 'prop-types';
import BaseNavigationBar from '../../../../shared/library/navigation-bar';
import DescriptionIcon from '../../../../shared/library/icons/nav/description.svg';
import StatsIcon from '../../../../shared/library/icons/nav/stats.svg';
import ProsIcon from '../../../../shared/library/icons/nav/pros.svg';
import AlternativesIcon from '../../../../shared/library/icons/nav/alternatives.svg';
import IntegrationsIcon from '../../../../shared/library/icons/nav/integrations.svg';
import BlogsIcon from '../../../../shared/library/icons/nav/blog.svg';
import DecisionsIcon from '../../../../shared/library/icons/nav/decisions.svg';
import glamorous from 'glamorous';
import {ASH, FOCUS_BLUE, GUNSMOKE} from '../../../../shared/style/colors';
import {NAVBAR_HEIGHT, PAGE_WIDTH} from '../../../../shared/style/dimensions';
import Jobs from '../../../../shared/library/icons/nav/jobs.svg';

const defaultActiveStyles = {
  color: FOCUS_BLUE,
  borderColor: FOCUS_BLUE
};

const activeStyles = {
  ...defaultActiveStyles,
  ' svg path': {
    fill: FOCUS_BLUE,
    stroke: FOCUS_BLUE
  }
};

const NavOuter = glamorous.div({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  borderBottom: `2px solid ${ASH}`,
  position: 'sticky',
  zIndex: 100,
  top: NAVBAR_HEIGHT
});

const JobsIcon = glamorous(Jobs)({
  width: 20,
  height: 20,
  ' path': {
    fill: GUNSMOKE
  }
});

const NavInner = glamorous.div({
  width: PAGE_WIDTH
});

const NavigationBar = forwardRef(
  (
    {
      showJobs,
      jobsCount,
      showDecisions,
      showProsCons,
      showAlternativeTools,
      showIntegrations,
      showPosts,
      showDescription,
      showStats
    },
    ref
  ) => {
    const allMenuOptions = [
      {
        name: 'Decisions',
        icon: <DecisionsIcon />,
        slug: 'decisions',
        activeStyles,
        visible: showDecisions
      },
      {name: 'Pros & Cons', icon: <ProsIcon />, slug: 'pros', activeStyles, visible: showProsCons},
      {
        name: 'Stats',
        icon: <StatsIcon />,
        slug: 'stats',
        activeStyles,
        visible: showStats
      },
      {
        name: 'Description',
        icon: <DescriptionIcon />,
        slug: 'description',
        activeStyles,
        visible: showDescription
      },
      {
        name: 'Jobs',
        icon: <JobsIcon />,
        slug: 'jobs',
        visible: showJobs,
        count: jobsCount,
        activeStyles
      },
      {
        name: 'Alternatives',
        icon: <AlternativesIcon />,
        slug: 'alternatives',
        activeStyles,
        visible: showAlternativeTools
      },
      {
        name: 'Integrations',
        icon: <IntegrationsIcon />,
        slug: 'integrations',
        activeStyles,
        visible: showIntegrations
      },
      {
        name: 'Blog Posts',
        icon: <BlogsIcon />,
        slug: 'posts',
        activeStyles,
        visible: showPosts
      }
    ];

    const visibleMenuItems = allMenuOptions
      .filter(item => {
        return item.visible === true;
      })
      .map(item => {
        return item;
      });

    return (
      <NavOuter>
        <NavInner>
          <BaseNavigationBar items={visibleMenuItems} ref={ref} />
        </NavInner>
      </NavOuter>
    );
  }
);

NavigationBar.propTypes = {
  showJobs: PropTypes.bool,
  jobsCount: PropTypes.number,
  showDecisions: PropTypes.bool,
  showProsCons: PropTypes.bool,
  showAlternativeTools: PropTypes.bool,
  showIntegrations: PropTypes.bool,
  showPosts: PropTypes.bool,
  showDescription: PropTypes.bool,
  showStats: PropTypes.bool
};

export default NavigationBar;
